import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TableContainer,
  Typography,
  Tooltip,
  useTheme,
  IconButton,
} from "@mui/material";
import { TableLoader, TableNotFound } from "src/Utils/TableLoader";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { Link } from "react-router-dom";
import { IRequestCompanyDocsInfo } from "src/Types/module/UpdateRequest/RequestCompanyDocsInfo";
import { getStatusLabel } from "src/Utils/Combined";

interface IProps {
  isLoading: boolean;
  companyDocsInfo: IRequestCompanyDocsInfo[];
}
const CompanyDocsIndex = ({ isLoading, companyDocsInfo }: IProps) => {
  const theme = useTheme();
  return (
    <div>
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>ID</TableCell>
              <TableCell>Company Name</TableCell>
              <TableCell>Status</TableCell>
              <TableCell>Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {isLoading ? (
              <TableLoader />
            ) : companyDocsInfo.length ? (
              <>
                {companyDocsInfo.map((sCompanyDocsInfo) => {
                  return (
                    <TableRow hover key={sCompanyDocsInfo.request_id}>
                      <TableCell>
                        <Typography
                          variant="body1"
                          color="text.primary"
                          gutterBottom
                          noWrap
                        >
                          {sCompanyDocsInfo.company_id}
                        </Typography>
                      </TableCell>

                      <TableCell>
                        <Typography
                          variant="body1"
                          color="text.primary"
                          gutterBottom
                          noWrap
                        >
                          {sCompanyDocsInfo.member_company_name}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        {getStatusLabel(sCompanyDocsInfo.status)}
                      </TableCell>

                      <TableCell>
                        <Link
                          to={`/update-request/company-docs/${sCompanyDocsInfo.request_id}?memberid=${sCompanyDocsInfo.user_member_id}`}
                        >
                          <Tooltip title="view" arrow>
                            <IconButton
                              sx={{
                                "&:hover": {
                                  background: theme.colors.primary.lighter,
                                },
                                color: theme.palette.primary.main,
                              }}
                              color="inherit"
                              size="small"
                            >
                              <VisibilityIcon fontSize="small" />
                            </IconButton>
                          </Tooltip>
                        </Link>
                      </TableCell>
                    </TableRow>
                  );
                })}
              </>
            ) : (
              <TableNotFound />
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
};

export default CompanyDocsIndex;
